import PGlobal from './PGlobal';
import Protocol from '../protocol.js';

export default class M {
    constructor(id, name) {
        this.moduleId = id;
        this.moduleName = name;
        this.onDomReady = null;
        this.listenPool = {};

        // 模块初始化
        Protocol.onSocketInit(PGlobal.platform, this.moduleName, this.moduleId);
        // 模块与服务器建立链接
        Protocol.onSocketConnect(PGlobal.platform, this.moduleName);
        // 模块与服务器建立链接
        Protocol.onSocketRegister(PGlobal.platform, this.moduleName, this.moduleId);
        // 接收消息
        Protocol.receiver(PGlobal.platform, this.moduleName);

        window[this.moduleName].message = (senderId, packageId, sessionId, messageId, protoBytes) => this.onMessage(senderId, packageId, sessionId, messageId, protoBytes);
        window[this.moduleName].domReady = () => {
            if(this.onDomReady) {
                this.onDomReady();
            }
        };
    }

    onMessage(senderId, packageId, sessionId, messageId, protoBytes) {
        if(this.listenPool[sessionId] && this.listenPool[sessionId][messageId]) {
            let list = this.listenPool[sessionId][messageId];
            let len = list.length;
            for(let i=0; i < len; ++i) {
                let obj = list[i];
                if(obj) {
                    let data;
                    if(obj.cl) {
                        let arr = new Uint8Array(protoBytes)
                        data = obj.cl.deserializeBinary(arr).toObject();
                    }
                    obj.func({
                        sid: sessionId,
                        mid: messageId,
                        data: data
                    });
                }
            }
        }
    }

    listen(sId, mId, cl, func) {
        if(!this.listenPool[sId]) {
            this.listenPool[sId] = {};
        }
        if(!this.listenPool[sId][mId]) {
            this.listenPool[sId][mId] = [];
        }
        this.listenPool[sId][mId].push({
            func: func,
            cl: cl
        });
    }

    send(to, sId, mId, proto) {
        let obj = {
            packageId: 0,
            senderId: this.moduleId,
            senderName: this.moduleName,
            receiverId: to,
            timeFlag: 0,
            sessionId: sId,
            messageId: mId,
            protoBytes: proto ? Array.from(proto.serializeBinary()) : []
        };
        Protocol.sender(PGlobal.platform, obj);
    }
}



// WEBPACK FOOTER //
// ./src/common/scripts/pixi/M.js